import React, { useState, useEffect } from "react";
import { doc, setDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { firestore } from "../../pagini/Firebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";  // Importă auth pentru a verifica utilizatorul autentificat
import "firebase/auth";
import "firebase/functions";
import "../stiluri/EditUserPopup.css";
import { useTranslation } from "react-i18next";

const sectiuni = [
  "dosar_social", "dosar_juridic", "dosar_financiar",
  "dosar_psihologic", "dosar_angajari", "date_personale",
  "galerie_foto", "date_contact", "istoric_actiuni",
  "social_ai", "privire_generala"
];

const niveluri = ["vizualizare", "editare", "stergere"];

const setCustomClaims = async (uid, role, permisiuni) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    console.error("User is not authenticated!");
    return;
  }

  try {
    // Retrieve the ID token for authentication in Firebase Function
    const idToken = await user.getIdToken();

    const functions = getFunctions();
    const setUserRole = httpsCallable(functions, "setUserRole");

    const response = await setUserRole({
      uid,
      role,
      sectiuni: permisiuni,
      token: idToken,// Make sure you include the token here if needed in your function.
    });

    console.log("Function response:", response);
  } catch (error) {
    console.error("Error setting custom claims:", error);
  }
};

const EditUserPopup = ({ selectedUser, onClose, onSave }) => {
  const [user, setUser] = useState({ ...selectedUser });
  const [avatarProgress, setAvatarProgress] = useState(0);

  useEffect(() => {
    const initialPermisiuni = {};
    sectiuni.forEach((sectiune) => {
      initialPermisiuni[sectiune] = selectedUser.permisiuni?.[sectiune] || {
        vizualizare: false,
        editare: false,
        stergere: false,
      };
    });
    setUser((prev) => ({ ...prev, permisiuni: initialPermisiuni }));
  }, [selectedUser]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const handlePermissionChange = (sectiune, nivel) => (e) => {
    const updatedPermisiuni = {
      ...user.permisiuni,
      [sectiune]: {
        ...user.permisiuni[sectiune],
        [nivel]: e.target.checked,
      },
    };
    setUser({ ...user, permisiuni: updatedPermisiuni });
  };
const { t } = useTranslation();
  const handleToggleAll = (sectiune) => {
    const current = user.permisiuni[sectiune];
    const allSelected = niveluri.every((nivel) => current[nivel]);
    const newPermisiuni = {};
    niveluri.forEach((nivel) => {
      newPermisiuni[nivel] = !allSelected;
    });
    setUser((prev) => ({
      ...prev,
      permisiuni: {
        ...prev.permisiuni,
        [sectiune]: newPermisiuni,
      },
    }));
  };

  const handleAvatarUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const storage = getStorage();
  const avatarRef = ref(storage, `avatars/${user.id}/poza_profil/${file.name}`);
  const uploadTask = uploadBytesResumable(avatarRef, file);

  uploadTask.on(
    "state_changed",
    (snapshot) => {
      const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      setAvatarProgress(progress);
    },
    (error) => {
      alert(t("errorUploadingAvatar"))
      alert(t("mustBeLoggedIn"))
    },
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        setUser((prev) => ({ ...prev, avatar_url: downloadURL }));
        setAvatarProgress(0); // Reset progress after upload
      });
    }
  );
};

  const handleSave = async () => {
  const auth = getAuth();
  const currentUser = auth.currentUser;

  if (!currentUser) {
    alert("Trebuie să te autentifici pentru a efectua această acțiune.");
    return;
  }

  if (!user || !user.cnp) {
    alert(t("missingCNP"))
    return;
  }

  try {
    const userRef = doc(firestore, "Utilizatori", user.id);
    await setDoc(userRef, user, { merge: true });

    // Call setCustomClaims and handle any error that occurs during this step
    try {
      await setCustomClaims(user.id, user.role, user.permisiuni);
    } catch (error) {
      console.error("Error setting custom claims:", error);
      alert(t("errorSettingClaims"))
      return;
    }

    onSave(user);
    alert(t("changesSaved"))
    onClose();
  } catch (error) {
    console.error("Eroare la salvarea datelor utilizatorului:", error);
alert(t("errorSavingUser"))  }
};


  return (
    <div className="edit-user-popup">
      <div className="edit-user-popup-content">
     <h3>{t("editUser")}</h3>

        <div className="input-row">
         <label htmlFor="cnp">{t("cnp")}</label>
          <input type="text" name="cnp" placeholder={t("cnp")} value={user.cnp || ""} readOnly />
        </div>

        <div className="input-row">
          <label htmlFor="nume">{t("lastName")}</label>
          <input type="text" name="nume" placeholder={t("lastName")} value={user.nume || ""} onChange={handleChange} />
        </div>

        <div className="input-row">
          <label htmlFor="prenume">{t("firstName")}</label>
          <input type="text" name="prenume" placeholder={t("firstName")} value={user.prenume || ""} onChange={handleChange} />
        </div>

        <div className="input-row">
          <label htmlFor="email">{t("email")}</label>
          <input type="email" name="email" placeholder={t("email")} value={user.email || ""} onChange={handleChange} />
        </div>

        <div className="input-row">
          <label htmlFor="telefon">{t("phone")}</label>
          <input type="text" name="telefon" placeholder={t("phone")} value={user.telefon || ""} onChange={handleChange} />
        </div>

        <div className="input-row">
          <label htmlFor="functie">{t("function")}</label>
          <input type="text" name="functie" placeholder={t("function")} value={user.functie || ""} onChange={handleChange} />
        </div>

        <div className="input-row">
          <label htmlFor="institutie">{t("institution")}</label>
          <input type="text" name="institutie" placeholder={t("institution")} value={user.institutie || ""} onChange={handleChange} />
        </div>

        <label htmlFor="role">{t("role")}</label>
        <select name="role" value={user.role || ""} onChange={handleChange}>
  <option value="">{t("selectRole")}</option>
  <option value="administrator">{t("administrator")}</option>
  <option value="utilizator">{t("user")}</option>
  <option value="director">{t("director")}</option>
        </select>

        <h4>{t("permissions")}</h4>
        <div className="permisiuni-grid">
          {sectiuni.map((sectiune) => (
            <div key={sectiune} className="sectiune-permisiuni">
              <div className="sectiune-header">
                <strong>{sectiune.replaceAll("_", " ")}</strong>
                <button className="btn-toggle-all" onClick={() => handleToggleAll(sectiune)}>
                 {t("selectAll")}
                </button>
              </div>
              <div className="niveluri">
                {niveluri.map((nivel) => (
                  <label key={nivel}>
                    <input
                      type="checkbox"
                      checked={user.permisiuni?.[sectiune]?.[nivel] || false}
                      onChange={handlePermissionChange(sectiune, nivel)}
                    />
                    {t(nivel)} 
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div>
          <h4>{t("profilePicture")}</h4>
          <input type="file" accept="image/*" onChange={handleAvatarUpload} />
          {avatarProgress > 0 && avatarProgress < 100 && (
            <div className="progress-bar">
              <div className="progress-bar-fill" style={{ width: `${avatarProgress}%` }}></div>
            </div>
          )}
        </div>

        <div className="buttons-container">
<button className="btn-save" onClick={handleSave}>{t("save")}</button>
<button className="close-buton" onClick={onClose}>{t("close")}</button>
        </div>
      </div>
    </div>
  );
};

export default EditUserPopup;
